// Shared level limits — keep in sync with backend feed post limits and pricing copy

export const getMaxResultsPerPage = (userLevel = 0) => {
  if (userLevel >= 100) return 100;
  if (userLevel >= 50) return 50;
  return 25;
};

export const getPostsPerDay = (userLevel = 0) => {
  if (userLevel >= 100) return 10;
  if (userLevel >= 50) return 5;
  return 1;
};

export const isResultsLimitAllowed = (limit, userLevel = 0) => {
  return limit <= getMaxResultsPerPage(userLevel);
};
